import type { SVGProps } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../lib/cn";
import { microcopy } from "../lib/microcopy";

export function Spinner({ className, "aria-label": label, ...props }: SVGProps<SVGSVGElement>) {
  return <Loader2 role="status" aria-label={label ?? microcopy("working")} className={cn("size-4 shrink-0 animate-spin text-aegold-700", className)} {...props} />;
}
